<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 トップページ スライド編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページ スライド編集画面
          form.form-horizontal
            .form-group
              label(for='言語').col-md-12 言語
              .col-md-12
                el-select(v-model='formdata.locale', disabled='', @change='changeLocale')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語') 
                  el-option(value='kr', label='韓国語')
            .form-group(v-if='formdata.entry_id')
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="formdata.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="formdata.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="formdata.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="formdata.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', v-model='formdata.title', placeholder='画面上には表示されません（コンテンツの識別に使います）')
            .form-group
              .form-group(v-if='savedImageLength')
                label.col-md-12 画像
                .col-md-12
                  el-table(:data='formdata.images')
                    el-table-column(label="image", width="300")
                      template(slot-scope="scope")
                        img(:src='scope.row.image_url', height='128')
                    el-table-column(property='image_url', label='image_url', width='500')
                    el-table-column(label='')
                      template(slot-scope='scope')
                        el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteImageConfirm(scope.$index)')
              .form-group(v-if='uploadedImagesLength')
                label.col-md-12 画像
                el-button(style='margin-left:18px', type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd', v-if='formdata.uploadedImages.length === 0')
                .col-md-12
                  el-table(:data='formdata.uploadedImages')
                    el-table-column(label='image', width='300')
                      template(slot-scope='scope')
                        img(:src='scope.row.image', height='128')
                    el-table-column(property='name', label='name', width='500')
                    el-table-column(label='')
                      template(slot-scope='scope')
                        el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteUpImageConfirm(scope.$index)') 
                input#btnFileAdd(type='file', style='visibility: hidden', @change='onFileAdd($event)', accept='image/*')
            h3.box-title レイヤー一覧
              el-table(:data='formdata.layers', style='width: 100%', max-height='500')
                el-table-column(label='id', width='100')
                  template(slot-scope='scope')
                    router-link(:to="{ path: '/swan/layer/edit', query: { id: scope.row.entry_id, locale: 'ja' }}")
                      | {{scope.row.entry_id}}
                el-table-column(label='タイトル', width='400')
                  template(slot-scope='scope')
                    router-link(:to="{ path: '/swan/layer/edit', query: { id: scope.row.entry_id, locale: 'ja' }}")
                      | {{scope.row.title}}
                el-table-column(label='種別', width='150')
                  template(slot-scope='scope')
                      | {{layer_types[scope.row.layer_type]}}
                el-table-column(fixed='right', label='Operations', width='200')
                  template(slot-scope='scope')
                    el-button(size='mini', type='primary', icon='el-icon-caret-top', @click='moveListUp(scope.$index)')
                    el-button(size='mini', type='primary', icon='el-icon-caret-bottom', @click='moveListDown(scope.$index)')
                    el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index)')
            .form-group
              label.col-md-12 レイヤー追加
              .col-md-12
                el-select(v-model='layerValue')  
                  el-option(v-for='(layer,index) in layerdata',:key="index",:value="index",:label="layer.title")
            .form-group
              el-button(@click='layerAdd', type='primary') 追加
            .form-group
              label.col-md-12 状態
              .col-md-12
                el-select(v-model='formdata.status')
                  el-option(value='draft', label='編集中')
                  el-option(value='open', label='公開')
            .form-group
              el-button(@click='register', type='primary') 登録

</template>

<script>
import LayerList from '@/views/components/swan/common/List'
import axios from 'axios'
export default {
  name: 'SlideEdit',
  data () {
    return {
      layerValue: '',
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      layerdata: {},
      formdata: {
        entry_id: '',
        locale: '',
        title: '',
        images: [],
        uploadedImages: [],
        layers: [],
        status: ''
      },
      layer_types: {
        text: 'テキスト',
        image_white: '画像（背景白）',
        image_black: '画像（背景黒）',
        video: '動画'
      }
    }
  },
  components: {
    LayerList
  },
  created () {
    this.savedImageLength = false
    this.uploadedImagesLength = false
    this.getLayerListData()
    if (this.$route.query.id) {
      this.getSlide(this.$route.query.id, this.$route.query.locale)
    } else {
      this.formdata.locale = 'ja'
      this.uploadedImagesLength = true
    }
    this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
    this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
    this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
    this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
  },
  mounted: function () {
  },
  methods: {
    changeLocale () {
      if (this.formdata.entry_id) {
        this.getSlide(this.formdata.entry_id, this.formdata.locale)
      }
    },
    getSlide (id, locale) {
      return axios({
        method: 'get',
        url: 'admin/swan/top_slide/edit?entry_id=' + id + '&locale=' + locale,
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        if (Object.keys(res.data).length) {
          var _data = res.data
          this.formdata.locale = _data.locale
          this.formdata.entry_id = _data.entry_id
          this.formdata.title = _data.title
          this.formdata.status = _data.status
          this.formdata.uploadedImages = []
          this.formdata.images = _data.images
          this.formdata.layers = _data.layers
          if (this.formdata.images.length > 0 && this.formdata.images[0].image_url !== '') {
            this.savedImageLength = true
          } else {
            this.uploadedImagesLength = true
          }
        } else {
          this.formdata.entry_id = id
          this.formdata.locale = locale
        }
      }).catch(function (error) {
        this.$message({
          type: 'error',
          message: error
        })
        console.log(error)
      })
    },
    getLayerListData () {
      return axios({
        method: 'get',
        url: '/admin/swan/top_layer',
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        var _contents = res.data.contents
        this.layerdata = _contents
        console.log(this.layerdata)
      }).catch(function (error) {
        console.log(error)
      })
    },
    layerAdd () {
      if (this.layerValue === '') {
        return
      }
      this.formdata.layers.push({ entry_id: this.layerdata[this.layerValue].entry_id, title: this.layerdata[this.layerValue].title })
    },
    moveListUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.layers.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.layers[orgIndex])
        this.formdata.layers = tmp
      }
    },
    moveListDown (orgIndex) {
      if (orgIndex < this.formdata.layers.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.layers.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.layers[orgIndex])
        this.formdata.layers = tmp
      }
    },
    deleteConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.layers.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteImageConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.images.splice(index, 1)
        this.savedImageLength = false
        this.uploadedImagesLength = true
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteUpImageConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.uploadedImages.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onBtnFileAdd (e) {
      document.getElementById('btnFileAdd').click()
    },
    onFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.formdata.uploadedImages.push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    },
    register: function () {
      let inputData = JSON.stringify(this.formdata)
      console.log(inputData)
      axios({
        method: 'POST',
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/top_slide/edit',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          self.result = response
          this.$message({
            type: 'success',
            message: 'completed'
          })
        })
        .catch((error) => {
          this.$message({
            type: 'info',
            message: 'no completed'
          })
          console.log(error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/top_slide/edit.vue